<template>
  <scroll-bar>
    <el-menu 
      mode="vertical" 
      :show-timeout="200" 
      :default-active="$route.path" 
      :collapse="isCollapse"  
      :default-openeds="openeds"  
      background-color="#ffffff" 
      text-color="#aaaaaa" 
      active-text-color="#FF6406">
      <sidebar-item :routes="routes"></sidebar-item>
    </el-menu>
  </scroll-bar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar'

export default {
  components: { SidebarItem, ScrollBar },
  data(){
    return {
      openeds: ['pms'] // 默认展开第一行菜单
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'routers'
    ]),
    routes() {
      // return this.$router.options.routes
      return this.routers
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  created() {
    // console.log("路由：", this.routers);
  }

}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue